<template>
  <div id="container">
    <div id="mapContainer"></div>
  </div>
</template>

<script>
import "leaflet/dist/leaflet.css";
import * as L from "leaflet";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import markerIconRetina from "leaflet/dist/images/marker-icon-2x.png";
const DefaultIcon = L.icon({
  iconUrl: markerIcon,
  iconRetinaUrl: markerIconRetina,
  shadowUrl: markerShadow,
  iconSize: [25, 41], // size of the icon
  iconAnchor: [12, 41], // point of the icon which will correspond to marker's location
  popupAnchor: [1, -34], // point from which the popup should open relative to the iconAnchor
  shadowSize: [41, 41], // size of the shadow
});
L.Marker.prototype.options.icon = DefaultIcon;

export default {
  name: "Map",
  props: ["coords", "code_ffvl"],
  data() {
    return {
      mapDiv: null,
      marker: null,
      center: [45, 4],
      token:
        "pk.eyJ1IjoiZ2lsbGVzODQ3NSIsImEiOiJjazdmcmtuM2YwNWZrM2VuNjlrbnNldGI3In0.NVN_OrsfDaW6RfsQzwY4jg",
    };
  },
  methods: {
    setupLeafletMap() {
      //   this.mapDiv = L.map("mapContainer").setView(this.coords, 13);
      const mxSat = L.tileLayer(
        `https://api.mapbox.com/styles/v1/mapbox/satellite-v9/tiles/256/{z}/{x}/{y}@2x?access_token=${this.token}`,
        {
          attribution:
            '&copy; <a href="https://www.mapbox.com/about/maps/">Mapbox</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
          tileSize: 512,
          zoomOffset: -1,
        }
      );
      //plan ign
      const planIGN = L.tileLayer(
        "https://data.geopf.fr/wmts?" +
          "&REQUEST=GetTile&SERVICE=WMTS&VERSION=1.0.0&TILEMATRIXSET=PM" +
          "&LAYER={ignLayer}&STYLE={style}&FORMAT={format}" +
          "&TILECOL={x}&TILEROW={y}&TILEMATRIX={z}",
        {
          ignLayer: "GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2",
          style: "normal",
          format: "image/png",
          service: "WMTS",
          //   opacity: 0.4,
          attribution: "Carte © IGN/Geoplateforme",
        }
      );
      //photos aeriennes
      const orthoIGN = L.tileLayer(
        "https://data.geopf.fr/wmts?" +
          "&REQUEST=GetTile&SERVICE=WMTS&VERSION=1.0.0&TILEMATRIXSET=PM" +
          "&LAYER={ignLayer}&STYLE={style}&FORMAT={format}" +
          "&TILECOL={x}&TILEROW={y}&TILEMATRIX={z}",
        {
          ignLayer: "ORTHOIMAGERY.ORTHOPHOTOS",
          style: "normal",
          format: "image/jpeg",
          service: "WMTS",
          attribution: "Carte © IGN/Geoplateforme",
        }
      );
      this.marker = L.marker(this.coords);
      const markersTerrains = L.layerGroup([this.marker]);
      this.mapDiv = L.map("mapContainer", {
        layers: [mxSat, markersTerrains],
      }).setView(this.coords, 13);
      const menuMap = {
        Satellite: mxSat,
        "Plan IGN": planIGN,
        "Photos IGN": orthoIGN,
      };
      //définition d'un controle d'affichage
      const layerControl = L.control.layers(menuMap).addTo(this.mapDiv);
      //   this.marker = L.marker(this.coords).addTo(this.mapDiv);

      // const url_mapbox = "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}"
      // L.tileLayer(
      //     url_mapbox,
      //     {
      //         attribution:
      //             'Map data (c) <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery (c) <a href="https://www.mapbox.com/">Mapbox</a>',
      //         maxZoom: 18,
      //         id: "mapbox/satellite-v9",
      //         accessToken: this.token,
      //     }
      // ).addTo(mapDiv);
      // L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      //     maxZoom: 19,
      //     attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      // }).addTo(this.mapDiv);
    },
  },
  mounted() {
    console.log("updated code ffvl", this.code_ffvl);
    this.setupLeafletMap();
    // const marker = L.marker(this.coords).addTo(this.mapDiv);
    if (this.code_ffvl) {
      const popupText = `<a href='https://federation.ffvl.fr/terrain/${this.code_ffvl}' target='_blank'>fiche terrain sur site ffvl </a>`;
      this.marker.bindPopup(popupText);
    }
  },
  updated() {
    // const icone = L.icon({
    //   iconUrl: "./marker-icon.png",
    //   shadowUrl: "./assets/marker-shadow.png",
    //   iconSize: [20, 20],
    //   shadowSize: [20, 20],
    //   iconAnchor: [22, 94], // point of the icon which will correspond to marker's location
    //   shadowAnchor: [4, 62], // the same for the shadow
    //   popupAnchor: [-3, -76], // point from which the popup should open relative to the iconAnchor
    // });
    // const circle = L.circle(this.coords, {
    //     color: 'red',
    //     fillColor: '#f03',
    //     fillOpacity: 0.5,
    //     radius: 50
    // }).addTo(this.mapDiv);
    this.mapDiv.setView(this.coords, 13);
    // this.marker = L.marker(this.coords).addTo(this.mapDiv);
    this.marker.setLatLng(this.coords);
    if (this.code_ffvl) {
      const popupText = `<a href='https://federation.ffvl.fr/terrain/${this.code_ffvl}' target='_blank'>fiche terrain sur site ffvl </a>`;
      this.marker.bindPopup(popupText);
    }
  },
};
</script>

<style>
#mapContainer {
  position: fixed;
  top: 25vh;
  left: 25vw;
  width: 50vw;
  height: 50vh;
}
</style>
